import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const RecordKeeping = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Record Keeping</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Min Record Retention (Months)"
              type="number"
              value={baseline.minRecordRetentionMonths}
              onChange={(e) => handleChange('minRecordRetentionMonths', parseInt(e.target.value))}
              inputProps={{ min: 6, max: 60 }}
              helperText="CAR Section 7, Series J - Minimum retention"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default RecordKeeping;
